import { Badge } from "@/components/ui/badge";
import { STATUS_LABEL, STATUS_STYLE } from "@/lib/format";

export default function StatusBadge({ status }) {
    const cls = STATUS_STYLE[status] || STATUS_STYLE.draft;
    const label = STATUS_LABEL[status] || status;
    return (
        <Badge variant="outline" className={`border ${cls} px-2.5 py-0.5 text-xs font-medium capitalize`} data-testid={`quote-status-${status}`}>
            {label}
        </Badge>
    );
}
